import React from 'react'

import { useHeaderHeight } from '@react-navigation/elements'
import { Stack } from '@zet/design-system/layout'

type HeaderHeightMarginProps = {
  children: React.ReactNode
}

const HeaderHeightMargin = ({ children }: HeaderHeightMarginProps) => {
  const headerHeight = useHeaderHeight()
  return <Stack style={{ marginTop: headerHeight }}>{children}</Stack>
}

export default HeaderHeightMargin
